export const availableComponents = {
  lobby: [
    { type: "banners", name: "argen.components.banners", icon: "banners" },
    { type: "blocks", name: "argen.components.blocks", icon: "blocks" },
    { type: "providersSlider", name: "argen.components.providersSlider", icon: "providers_slider" },
    { type: "gamesRow", name: "argen.components.gamesRow", icon: "games_row" },
    { type: "latestWins", name: "mell.components.latestWins", icon: "last_wins" },
  ],
  profile: [{ type: "profileButton", name: "argen.components.profileButton", icon: "profile_button" }],
}

export const componentListHeaders = {
  lobby: "argen.componentListHeaders.lobby",
  profile: "argen.componentListHeaders.profile",
}
